import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'planState',
})
export class PlanStateTranslatePipe implements PipeTransform {
  transform(value: string): string {
    return (
      {
        notStarted: '未开始',
        inProgress: '进行中',
        suspended: '已暂停',
        haveEnded: '已结束',
      }[value] || value
    );
  }
}
